/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".p-container[_ngcontent-%COMP%]{padding:10px 10px 5px!important}"];
export { styles as styles };
